export default __webpack_public_path__ + "static/media/DependantIcon.17dd267f.svg";